import axios from '../helpers/axios';
import * as errors from '../errors';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const getImprints = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/imprints');
    dispatch({ type: 'SET_ALL_IMPRINTS', payload: res.data });
  } catch (e) {
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};

export const createImprint =
  (imprint: any, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.post('/api/imprint/', imprint);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyCreated'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'ADD_IMPRINT', payload: res.data });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const editImprint =
  (imprint: any, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.put('/api/imprint/', imprint);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyEdited'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'EDIT_IMPRINT', payload: imprint });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const deleteImprint =
  (imprint_id: string, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.delete('/api/imprint/', { params: { imprint_id } });
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyDeleted'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'REMOVE_IMPRINT', payload: imprint_id });
    } catch (e: any) {
      if (e?.response?.status === 428) {
        notify({
          title: getTranslationKey('error'),
          message: getTranslationKey('customDomains.deleteImprintErrorInUse'),
          status: 'error',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 10000
        });
      } else errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };
